// import slick from 'slick-carousel';
import Swiper from 'swiper'

export default function sliders() {
    const swiper = new Swiper('.index-slider', {
        // cssMode: true,
        // mousewheel: true,
        effect: 'fade',
        keyboard: true,
        speed: 800,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        }
      });


}